import add from '../assets/add.svg';
import addCollection from '../assets/add-collection.svg';
import addCollectionIcon from '../assets/addCollection.svg';
import addedCollection from '../assets/addedCollection.svg';
import alleTab from '../assets/alleTab.svg';
import alleTabBold from '../assets/alleTab-Bold.svg';
import arrowDown from '../assets/arrow-down.svg';
import arrowDropdownFilled from '../assets/arrow-dropdown-filled.svg';
import arrowLeft from '../assets/arrow-left.svg';
import arrowRight from '../assets/arrow-right.svg';
import arrowUp from '../assets/arrow-up.svg';
import arrowUpLong from '../assets/arrow-up-long.svg';
import arrowUpRightLong from '../assets/arrow-up-right-long.svg';
import audioArtifact from '../assets/artifacts/audio-artifact.svg';
import documentArtifact from '../assets/artifacts/document-artifact.svg';
import imageArtifact from '../assets/artifacts/image-artifact.svg';
import addIcon from '../assets/assistant/add-icon.svg';
import addLink from '../assets/assistant/add-link.svg';
import ai from '../assets/assistant/ai.svg';
import aiChatsOld from '../assets/assistant/ai-chats-old.svg';
import aiGroupTasks from '../assets/assistant/ai-group-tasks.svg';
import aiGroupTasksOutlined from '../assets/assistant/ai-group-tasks-outlined.svg';
import aiLearningObjectiveGeneration from '../assets/assistant/ai-learning-objective-generation.svg';
import aiLearningObjectiveGenerationOutlined from '../assets/assistant/ai-learning-objective-generation-outlined.svg';
import aiLessonPlanning from '../assets/assistant/ai-lesson-planning.svg';
import aiLessonPlanningOutlined from '../assets/assistant/ai-lesson-planning-outlined.svg';
import aiLessonSeriesPlanning from '../assets/assistant/ai-lesson-series-planning.svg';
import aiLessonSeriesPlanningOutlined from '../assets/assistant/ai-lesson-series-planning-outlined.svg';
import aiMindItem from '../assets/assistant/ai-mind-item.svg';
import aiOutlined from '../assets/assistant/ai-outlined.svg';
import aiPen from '../assets/assistant/ai-pen.svg';
import arrowRightLong from '../assets/assistant/arrow-right-long.svg';
import boldGallery from '../assets/assistant/bold-gallery.svg';
import chatMessageArtifactDocument from '../assets/assistant/chat-message-artifact-document.svg';
import checkboxCircle from '../assets/assistant/checkbox-circle.svg';
import closeCircle from '../assets/assistant/close-circle.svg';
import cloudSaved from '../assets/assistant/cloud-saved.svg';
import createWorksheet from '../assets/assistant/create-worksheet.svg';
import createWorksheetOutlined from '../assets/assistant/create-worksheet-outlined.svg';
import disabledAddLink from '../assets/assistant/disabled-add-link.svg';
import dislike from '../assets/assistant/dislike.svg';
import dislikeBold from '../assets/assistant/dislikeBold.svg';
import edit from '../assets/assistant/edit.svg';
import essayTemplate from '../assets/assistant/essay-template.svg';
import essayTemplateOutlined from '../assets/assistant/essay-template-outlined.svg';
import explainTopic from '../assets/assistant/explain-topic.svg';
import explainTopicOutlined from '../assets/assistant/explain-topic-outlined.svg';
import exportIcon from '../assets/assistant/export.svg';
import addDocumentBold from '../assets/assistant/features/addDocumentBold.svg';
import bulbBold from '../assets/assistant/features/bulbBold.svg';
import checklistBold from '../assets/assistant/features/checklistBold.svg';
import shapesBold from '../assets/assistant/features/shapesBold.svg';
import simplifyBold from '../assets/assistant/features/simplifyBold.svg';
import slidesBold from '../assets/assistant/features/slidesBold.svg';
import starWandBold from '../assets/assistant/features/starWandBold.svg';
import textDocumentBold from '../assets/assistant/features/textDocumentBold.svg';
import gallery from '../assets/assistant/gallery.svg';
import galleryOutlined from '../assets/assistant/gallery-outlined.svg';
import infoCircle from '../assets/assistant/info-circle.svg';
import like from '../assets/assistant/like.svg';
import likeBold from '../assets/assistant/likeBold.svg';
import magicPenBold from '../assets/assistant/magicpenBold.svg';
import maximize from '../assets/assistant/maximize.svg';
import microphone from '../assets/assistant/microphone.svg';
import minimize from '../assets/assistant/minimize.svg';
import moreCircle from '../assets/assistant/more-circle.svg';
import move from '../assets/assistant/move.svg';
import paperclipStraight from '../assets/assistant/paperclip-straight.svg';
import pauseBold from '../assets/assistant/pause-bold.svg';
import pauseCircle from '../assets/assistant/pause-circle.svg';
import playCircle from '../assets/assistant/play-circle.svg';
import recent from '../assets/assistant/recent.svg';
import refresh from '../assets/assistant/refresh.svg';
import refreshRound from '../assets/assistant/refresh-round.svg';
import sendBold from '../assets/assistant/sendBold.svg';
import stopCircle from '../assets/assistant/stop-circle.svg';
import table from '../assets/assistant/table.svg';
import transcript from '../assets/assistant/transcript.svg';
import volume from '../assets/assistant/volume.svg';
import volumeBlue from '../assets/assistant/volume-blue.svg';
import defaultFileIcon from '../assets/attachments/defaultFileIcon.svg';
import docFileIcon from '../assets/attachments/docFileIcon.svg';
import folderIcon from '../assets/attachments/folderIcon.svg';
import jpgFileIcon from '../assets/attachments/jpgFileIcon.svg';
import mp3FileIcon from '../assets/attachments/mp3FileIcon.svg';
import mp4FileIcon from '../assets/attachments/mp4FileIcon.svg';
import pdfFileIcon from '../assets/attachments/pdfFileIcon.svg';
import pptFileIcon from '../assets/attachments/pptFileIcon.svg';
import txtFileIcon from '../assets/attachments/txtFileIcon.svg';
import xlsFileIcon from '../assets/attachments/xlsFileIcon.svg';
import back from '../assets/back.svg';
import book from '../assets/book.svg';
import bookmark from '../assets/bookmark.svg';
import bookmarkAdded from '../assets/bookmark-added.svg';
import calendar from '../assets/calendar.svg';
import checkOutlineVerify from '../assets/check-outline-verify.svg';
import checkSquare from '../assets/check-square.svg';
import checkVerify from '../assets/check-verify.svg';
import checkCircleFilled from '../assets/checkCircleFilled.svg';
import clipboardText from '../assets/clipboard-text.svg';
import close from '../assets/close.svg';
import collectionsFolder from '../assets/collectionsFolder.svg';
import copy from '../assets/copy.svg';
import attachments from '../assets/course/attachments.svg';
import check from '../assets/course/check.svg';
import clock from '../assets/course/clock.svg';
import courseProgress from '../assets/course/course-inprogress.svg';
import courseSuccess from '../assets/course/course-successfull.svg';
import heart from '../assets/course/heart.svg';
import importIcon from '../assets/course/import.svg';
import pause from '../assets/course/pause.svg';
import playOutlined from '../assets/course/play-outlined.svg';
import progressTab from '../assets/course/progress-tab.svg';
import progressTabBold from '../assets/course/progress-tab-bold.svg';
import successTab from '../assets/course/success-tab.svg';
import successTabBold from '../assets/course/success-tab-bold.svg';
import creditCard from '../assets/creditCard.svg';
import docText from '../assets/doc-text.svg';
import download from '../assets/download.svg';
import downloadAsDocx from '../assets/download-as-docx.svg';
import downloadAsPdf from '../assets/download-as-pdf.svg';
import downloadDocumentIcon from '../assets/downloadDocument.svg';
import dropdownClosedSmall from '../assets/dropdownClosedSmall.svg';
import dropdownOpenSmall from '../assets/dropdownOpenSmall.svg';
import editPen from '../assets/edit-pen.svg';
import editCollection from '../assets/editCollection.svg';
import emojiNormal from '../assets/emoji-normal.svg';
import emptyState from '../assets/empty-state.svg';
import errorFlatline from '../assets/error-flatline.svg';
import eyeClosed from '../assets/eye-closed.svg';
import eyeOpen from '../assets/eye-open.svg';
import folderAddPurple from '../assets/folder-add-purple.svg';
import folderRemovePurple from '../assets/folder-remove-purple.svg';
import hamburger from '../assets/hamburger.svg';
import downloadFileIcon from '../assets/import.svg';
import invalidLink from '../assets/invalid-url.svg';
import licence from '../assets/licence.svg';
import muLogo from '../assets/MuLogo.svg';
import microphone2 from '../assets/microphone-2.svg';
import mindItemTab from '../assets/mindItemTab.svg';
import mindItemTabBold from '../assets/mindItemTab-Bold.svg';
import minusCircle from '../assets/minusCircle.svg';
import more from '../assets/more.svg';
import muLogoBagOnboarding from '../assets/mu-logo-bag-onboarding.svg';
import myContent from '../assets/my-content.svg';
import notFound from '../assets/not-found.svg';
import location from '../assets/onboarding/AutocompleteClose.svg';
import moveDragAndDrop from '../assets/onboarding/move.svg';
import biology from '../assets/onboarding/subjects/biologie.svg';
import chemistry from '../assets/onboarding/subjects/chemie.svg';
import daz from '../assets/onboarding/subjects/daz.svg';
import german from '../assets/onboarding/subjects/deutsch.svg';
import didactics from '../assets/onboarding/subjects/didaktik.svg';
import english from '../assets/onboarding/subjects/englisch.svg';
import geography from '../assets/onboarding/subjects/erdkunde.svg';
import philosophy from '../assets/onboarding/subjects/ethik-philosophie.svg';
import french from '../assets/onboarding/subjects/franzosisch.svg';
import history from '../assets/onboarding/subjects/geschichte.svg';
import homeEconomics from '../assets/onboarding/subjects/hauswirtschaft.svg';
import computerScience from '../assets/onboarding/subjects/informatik.svg';
import interdisciplinary from '../assets/onboarding/subjects/interdisciplinary.svg';
import art from '../assets/onboarding/subjects/kunst.svg';
import latin from '../assets/onboarding/subjects/latein.svg';
import mathematics from '../assets/onboarding/subjects/mathematik.svg';
import music from '../assets/onboarding/subjects/musik.svg';
import naturalSciences from '../assets/onboarding/subjects/naturwissenschaften.svg';
import physics from '../assets/onboarding/subjects/physik.svg';
import politics from '../assets/onboarding/subjects/politik.svg';
import religion from '../assets/onboarding/subjects/religion.svg';
import generalStudies from '../assets/onboarding/subjects/sachunterricht.svg';
import spanish from '../assets/onboarding/subjects/spanisch.svg';
import physicalEducation from '../assets/onboarding/subjects/sport.svg';
import economics from '../assets/onboarding/subjects/wirtschaft.svg';
import outlineStar from '../assets/outline-star.svg';
import paperclip from '../assets/paperclip.svg';
import paypal from '../assets/paypal.svg';
import play from '../assets/play.svg';
import printer from '../assets/printer.svg';
import productTab from '../assets/productTab.svg';
import productTabBold from '../assets/productTab-Bold.svg';
import invoice from '../assets/profile/icons/invoice.svg';
import upgradeSubscription from '../assets/profile/icons/upgrade-subscription.svg';
import profileTwoUsers from '../assets/profileTwoUsers.svg';
import publisher from '../assets/publisher.svg';
import readerBackButton from '../assets/reader-back-button.svg';
import readerNextButton from '../assets/reader-next-button.svg';
import schoolType from '../assets/schoolType.svg';
import search from '../assets/search.svg';
import searchDone from '../assets/search-done.svg';
import searchStatus from '../assets/search-status.svg';
import sepa from '../assets/sepa.svg';
import share from '../assets/share.svg';
import shareVideo from '../assets/share-video.svg';
import aiTools from '../assets/sideNav/ai.svg';
import arrowDropDown from '../assets/sideNav/arrow-drop-down.svg';
import arrowDropUp from '../assets/sideNav/arrow-drop-up.svg';
import arrowLeftTooltip from '../assets/sideNav/arrow-left.svg';
import arrowUpOutline from '../assets/sideNav/arrow-up-outline.svg';
import cards from '../assets/sideNav/cards.svg';
import clipboard from '../assets/sideNav/clipboard.svg';
import downloads from '../assets/sideNav/downloads.svg';
import folderFavourite from '../assets/sideNav/folder-favourite.svg';
import home from '../assets/sideNav/home.svg';
import logout from '../assets/sideNav/logout.svg';
import medal from '../assets/sideNav/medal.svg';
import message from '../assets/sideNav/message.svg';
import messageFavorite from '../assets/sideNav/message-favorite.svg';
import messageQuestion from '../assets/sideNav/message-question.svg';
import muLogoBag from '../assets/sideNav/mu-logo-bag.svg';
import muLogoFull from '../assets/sideNav/mu-logo-full.svg';
import paragraph from '../assets/sideNav/paragraph.svg';
import profileCircle from '../assets/sideNav/profile-circle.svg';
import save from '../assets/sideNav/save.svg';
import searchNormal from '../assets/sideNav/search-normal.svg';
import teacherNav from '../assets/sideNav/teacher.svg';
import sort from '../assets/sort.svg';
import starFilled from '../assets/star-filled.svg';
import starFilledPurple from '../assets/star-filled-purple.svg';
import starPurple from '../assets/star-purple.svg';
import starBanner from '../assets/star-upgrade.svg';
import tag from '../assets/tag.svg';
import teacher from '../assets/teacher.svg';
import trash from '../assets/trash.svg';
import user from '../assets/user.svg';
import userTesting from '../assets/user-testing.svg';
import videoTab from '../assets/videoTab.svg';
import videoTabBold from '../assets/videoTab-Bold.svg';
import zeroResultsMobile from '../assets/zero-results-mobile.svg';
import zeroResultsTablet from '../assets/zero-results-tablet.svg';

const icons = {
	add,
	addCollection,
	alleTab,
	alleTabBold,
	arrowDown,
	arrowDropdownFilled,
	arrowLeft,
	arrowUp,
	arrowUpRightLong,
	arrowUpLong,
	arrowRight,
	arrowRightLong,
	attachments,
	book,
	bookmark,
	bookmarkAdded,
	search,
	calendar,
	check,
	checkVerify,
	checkOutlineVerify,
	checkSquare,
	clipboardText,
	clock,
	close,
	copy,
	docText,
	download,
	downloadAsPdf,
	downloadAsDocx,
	dropdownOpenSmall,
	dropdownClosedSmall,
	eyeOpen,
	eyeClosed,
	folderAddPurple,
	folderRemovePurple,
	heart,
	invalidLink,
	mindItemTab,
	mindItemTabBold,
	paperclip,
	pause,
	play,
	playOutlined,
	printer,
	productTab,
	productTabBold,
	publisher,
	searchDone,
	searchStatus,
	share,
	sort,
	starFilled,
	starFilledPurple,
	starPurple,
	tag,
	teacher,
	trash,
	userTesting,
	videoTab,
	videoTabBold,
	zeroResultsMobile,
	zeroResultsTablet,
	home,
	searchNormal,
	downloads,
	clipboard,
	teacherNav,
	folderFavourite,
	medal,
	message,
	messageFavorite,
	messageQuestion,
	arrowUpOutline,
	muLogoBag,
	muLogoBagOnboarding,
	muLogo,
	paragraph,
	save,
	hamburger,
	profileCircle,
	cards,
	logout,
	muLogoFull,
	arrowLeftTooltip,
	user,
	importIcon,
	courseSuccess,
	courseProgress,
	arrowDropUp,
	arrowDropDown,
	progressTab,
	progressTabBold,
	successTab,
	successTabBold,
	maximize,
	minimize,
	magicPenBold,
	sendBold,
	refresh,
	edit,
	like,
	dislike,
	stopCircle,
	likeBold,
	dislikeBold,
	ai,
	aiOutlined,
	location,
	moveDragAndDrop,
	english,
	german,
	history,
	biology,
	chemistry,
	daz,
	philosophy,
	french,
	geography,
	homeEconomics,
	computerScience,
	art,
	latin,
	mathematics,
	didactics,
	music,
	naturalSciences,
	physics,
	politics,
	religion,
	generalStudies,
	spanish,
	physicalEducation,
	economics,
	interdisciplinary,
	infoCircle,
	addDocumentBold,
	bulbBold,
	slidesBold,
	textDocumentBold,
	shapesBold,
	simplifyBold,
	starWandBold,
	checklistBold,
	aiMindItem,
	editPen,
	upgradeSubscription,
	more,
	aiPen,
	closeCircle,
	collectionsFolder,
	sepa,
	paypal,
	creditCard,
	invoice,
	emptyState,
	editCollection,
	recent,
	aiGroupTasks,
	aiGroupTasksOutlined,
	aiLearningObjectiveGeneration,
	aiLearningObjectiveGenerationOutlined,
	aiLessonSeriesPlanning,
	aiLessonSeriesPlanningOutlined,
	aiLessonPlanning,
	aiLessonPlanningOutlined,
	createWorksheet,
	createWorksheetOutlined,
	essayTemplate,
	essayTemplateOutlined,
	explainTopic,
	explainTopicOutlined,
	addCollectionIcon,
	addedCollection,
	profileTwoUsers,
	minusCircle,
	back,
	defaultFileIcon,
	docFileIcon,
	folderIcon,
	jpgFileIcon,
	mp3FileIcon,
	mp4FileIcon,
	pdfFileIcon,
	pptFileIcon,
	txtFileIcon,
	xlsFileIcon,
	downloadFileIcon,
	paperclipStraight,
	addLink,
	disabledAddLink,
	readerBackButton,
	readerNextButton,
	shareVideo,
	starBanner,
	downloadDocumentIcon,
	exportIcon,
	addIcon,
	checkboxCircle,
	outlineStar,
	moreCircle,
	emojiNormal,
	notFound,
	errorFlatline,
	chatMessageArtifactDocument,
	licence,
	refreshRound,
	cloudSaved,
	aiTools,
	move,
	aiChatsOld,
	table,
	gallery,
	galleryOutlined,
	checkCircleFilled,
	boldGallery,
	microphone,
	microphone2,
	volume,
	volumeBlue,
	pauseBold,
	transcript,
	myContent,
	schoolType,
	documentArtifact,
	imageArtifact,
	audioArtifact,
	playCircle,
	pauseCircle,
};

export type IconName = keyof typeof icons;

const getMuiIcon = (icon: IconName) => icons[icon];

export default getMuiIcon;
